import React, { useEffect, useState } from 'react';

interface VoiceVisualizerProps {
  micLevel: number;
  speakerLevel: number;
  isSpeaking: boolean;
  isActive: boolean;
}

export const VoiceVisualizer: React.FC<VoiceVisualizerProps> = ({ micLevel, speakerLevel, isSpeaking, isActive }) => {
  const [bars, setBars] = useState<number[]>(new Array(15).fill(10));

  useEffect(() => {
    if (!isActive) return;

    const interval = setInterval(() => {
      const level = isSpeaking ? speakerLevel : micLevel;
      // Generate heights with some variance to look organic
      setBars(prev => prev.map((_, i) => {
        const factor = Math.sin((i / prev.length) * Math.PI); // humped distribution
        const noise = Math.random() * 0.3 + 0.7;
        const targetHeight = Math.max(10, Math.min(100, level * 95 * factor * noise + 10));
        return targetHeight;
      }));
    }, 50);

    return () => clearInterval(interval);
  }, [isActive, isSpeaking, micLevel, speakerLevel]);

  if (!isActive) return null;

  return (
    <div className="flex flex-col items-center justify-center py-5 px-6 bg-slate-900/40 backdrop-blur-2xl border border-white/5 rounded-[2rem] max-w-sm mx-auto space-y-3 animate-in fade-in slide-in-from-bottom-4 duration-500 shadow-2xl relative overflow-hidden group">
      <div className="absolute inset-0 bg-cyan-500/5 blur-xl group-hover:bg-cyan-500/10 transition-all duration-700 pointer-events-none"></div>
      <div className="flex items-end justify-center h-12 space-x-1 w-full relative z-10">
        {bars.map((height, i) => (
          <div
            key={i}
            style={{ height: `${height}%` }}
            className={`w-1 rounded-full transition-all duration-100 ${
              isSpeaking 
                ? 'bg-gradient-to-t from-cyan-500 via-cyan-400 to-blue-500 shadow-[0_0_12px_rgba(34,211,238,0.5)]' 
                : 'bg-gradient-to-t from-cyan-400 via-teal-400 to-indigo-500 shadow-[0_0_12px_rgba(34,211,238,0.3)]'
            }`}
          />
        ))}
      </div>
      <span className="text-[9px] font-black uppercase tracking-[0.25em] text-cyan-400 animate-pulse relative z-10 select-none">
        {isSpeaking ? 'BABA Speaking' : 'Listening...'}
      </span>
    </div>
  );
};
